export function scrollToHash(hash, root = document) {
  if (!hash || hash === "#") return false;

  const id = decodeURIComponent(hash.slice(1));
  const target = root.getElementById(id);
  if (!target) return false;

  target.scrollIntoView({ block: "start" });
  return true;
}
